import script from "./UserProfileMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserProfileMenu.vue?vue&type=script&lang=ts&setup=true"

import "./UserProfileMenu.vue?vue&type=style&index=0&id=0dbffeae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dbffeae"]])

export default __exports__